import React from 'react';
import { VideoFeatures } from '@/store/videoFeatures';
import { VideoControlsTab } from './tabs/VideoControlsTab';
import { VideoStyleTab } from './tabs/VideoStyleTab';
import { MasterControlToggle } from './tabs/MasterControlToggle';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface VideoControlsOriginalProps {
  features: VideoFeatures;
  setFeature: <K extends keyof VideoFeatures>(key: K, value: VideoFeatures[K]) => void;
}

export const VideoControlsOriginal: React.FC<VideoControlsOriginalProps> = ({ 
  features, 
  setFeature 
}) => {
  const isControlsEnabled = features.showControls;

  return (
    <div className="flex flex-col h-full">
      {/* Conteúdo scrollable único */}
      <div className="flex-1 overflow-y-auto px-6 py-6 premium-scroll">
        <div className="space-y-6">
          {/* 1️⃣ TOPO - Toggle Master (SEMPRE VISÍVEL) */}
          <MasterControlToggle features={features} setFeature={setFeature} />
          
          {/* 2️⃣ CONTEÚDO - Só aparece quando ativado */}
          {isControlsEnabled && (
            <motion.div
              key="controls-content"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ 
                duration: 0.25, 
                ease: [0.16, 1, 0.3, 1]
              }}
              className="space-y-6"
            >
              {/* Personalizações (ícone + tema) */}
              <VideoStyleTab features={features} setFeature={setFeature} />
              
              {/* Comportamento dos Controles */}
              <VideoControlsTab features={features} setFeature={setFeature} />
            </motion.div>
          )}
        </div>
      </div>
    </div>
  );
};
